// Simple API service for menu operations
const API_BASE_URL = 'http://localhost:3001/api'

class MenuApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    }

    try {
      const response = await fetch(url, config)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      // Handle responses with no content (like DELETE 204)
      if (response.status === 204 || response.headers.get('content-length') === '0') {
        return null
      }
      
      return await response.json()
    } catch (error) {
      console.error('API request failed:', error)
      throw error
    }
  }

  // Get all menus (list with counts only) - POST method
  async getMenus(menuType = null) {
    // Use external API for menu list
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/menulist', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ menuType: menuType })
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }

  // Get detailed menu with sections - POST method
  async getMenuDetails(menuId, menuType = null) {
    // Use external API for menu details
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/menudetails', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ menuId, menuType })
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }

  // Create a new menu
  async createMenu(menuData) {
    // Use external API for creating menu
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/addmenu', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(menuData)
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    const result = await response.json()
    
    // Check if the API response indicates success
    if (!result.success) {
      throw new Error(result.response_message || 'Menu creation failed')
    }
    
    return result
  }

  // Update a menu (name, description) - POST method
  async updateMenu(menuId, menuData) {
    // Debug: Log the received data
    console.log('updateMenu called with:', { menuId, menuData })
    
    // Ensure menuType is always present
    const menuType = menuData.menuType || 'FTT'
    console.log('Using menuType:', menuType)
    
    // Use external API for updating menu (name, description)
    const requestBody = { 
      menuId, 
      menuType: menuType,
      ...menuData 
    }
    
    console.log('Request body being sent:', requestBody)
    
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/updatemenu', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }

  // Update menu data (sections, items) - POST method
  async updateMenuData(menuId, menuData) {
    // Debug: Log the received data
    console.log('updateMenuData called with:', { menuId, menuData })
    
    // Ensure menuType is always present
    const menuType = menuData.menuType || 'FTT'
    console.log('Using menuType:', menuType)
    
    // Use external API for updating menu data (sections, items)
    const requestBody = { 
      menuId, 
      menuType: menuType,
      ...menuData 
    }
    
    console.log('Request body being sent:', requestBody)
    
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/updatemenudata', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }

  // Delete a menu - POST method
  async deleteMenu(menuId, menuType) {
    // Use external API for deleting menu
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/deletemenu', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ menuId, menuType })
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }

  // Set batch menu roster - POST method
  async setBatchMenuRoster(assignments) {
    // Use external API for setting batch menu roster
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/setbatchmenuroster', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ assignments })
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }

  // Get batch menu roster - POST method
  async getBatchMenuRoster(year, month) {
    // Use external API for getting batch menu roster
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/getbatchmenuroster', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ year, month })
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }

  // Remove menu from specific day - POST method
  async removeMenuFromDay(date, menuType) {
    // Use external API for removing menu from day
    const response = await fetch('https://authalt.bsynapse.com/atmantannuggets/removemenufromday', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ date, menuType })
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return response.json()
  }
}

const menuApiService = new MenuApiService()
export default menuApiService
